import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogoIndicadoresService {

  constructor() { }

  catalogoTipoDocumento() {
    return [
      { clave: 10, valor: 'CANAL MODERNO' },
      { clave: 20, valor: 'CANAL TRADICIONAL' }
    ]
  }

  catalogoOpciones() {
    return [
      { clave: 1, valor: 'SI' },
      { clave: 0, valor: 'NO' }
    ]
  }

  catalogoAnio() {
    let anioIni = 2021;
    let anioFin = new Date().getFullYear();
    let cmb = [];
    for (let index = anioIni; index <= anioFin; index++) {
      cmb.push( { clave: index, valor: index });
    }
    return cmb;
    // return [
    //   { clave: 2021, valor: '2021' },
    //   { clave: 2022, valor: '2022' }
    // ]
  }

  catalogoMeses() {
    return [
      { clave: 1, valor: 'Enero' },
      { clave: 2, valor: 'Febrero' },
      { clave: 3, valor: 'Marzo' },
      { clave: 4, valor: 'Abril' },
      { clave: 5, valor: 'Mayo' },
      { clave: 6, valor: 'Junio' },
      { clave: 7, valor: 'Julio' },
      { clave: 8, valor: 'Agosto' },
      { clave: 9, valor: 'Septiembre' },
      { clave: 10, valor: 'Octubre' },
      { clave: 11, valor: 'Noviembre' },
      { clave: 12, valor: 'Diciembre' },
    ]
  }
  
/* T25111 add presupuesto promocional
ALCANCE: comentar definiciones de cabecera de plantilla y reporte. Omite campos CANAL, SUBCANAL Y GRUPO CLIENTES
NO BORRAR, SE ESPERA A FUTURO ACTIVAR
*/
  csvCabeceraPresuPromocional(){
    return [[
      'ORGANIZACION_VENTA', 
      'DESCRIPCION_ORGANIZACION_VENTA', 
      'CANAL_VENTA', 
      'DESCRIPCION_CANAL_VENTA', 
      'UNIDAD_NEGOCIO', 
      'DESCRIPCION_UNIDAD_NEGOCIO', 
      /*'CANAL', 
      'DESCRIPCION_CANAL', 
      'SUBCANAL', 
      'DESCRIPCION_SUBCANAL', 
      'GRUPO_CLIENTE', 
      'DESCRIPCION_GRUPO_CLIENTE', */
      'ID_MATERIAL', 
      'DESCRIPCION_MATERIAL', 
      'MACROCATEGORIA', 
      'DESCRIPCION_MACROCATEGORIA', 
      'ID_CATEGORIA', 
      'DESCRIPCION_CATEGORIA', 
      'ID_SUBCATEGORIA', 
      'DESCRIPCION_SUBCATEGORIA', 
      'ID_MARCA', 
      'DESCRIPCION_MARCA', 
      'MES_1', 
      'MES_2', 
      'MES_3', 
      'MES_4', 
      'MES_5', 
      'MES_6', 
      'MES_7', 
      'MES_8', 
      'MES_9', 
      'MES_10', 
      'MES_11', 
      'MES_12',
    ]]
  }
  

  reporteCabeceraPresuPromocional(){
    return [[ 
    'ANIO',
    'ORGANIZACION_VENTA', 
    'DESCRIPCION_ORGANIZACION_VENTA', 
    'CANAL_VENTA', 
    'DESCRIPCION_CANAL_VENTA', 
    'UNIDAD_NEGOCIO', 
    'DESCRIPCION_UNIDAD_NEGOCIO', 
    /*'CANAL', 
    'DESCRIPCION_CANAL', 
    'SUBCANAL', 
    'DESCRIPCION_SUBCANAL',
    'GRUPO_CLIENTE', 
    'DESCRIPCION_GRUPO_CLIENTE',*/
    'ID_MATERIAL', 
    'DESCRIPCION_MATERIAL', 
    'MACROCATEGORIA', 
    'DESCRIPCION_MACROCATEGORIA', 
    'ID_CATEGORIA', 
    'DESCRIPCION_CATEGORIA', 
    'ID_SUBCATEGORIA', 
    'DESCRIPCION_SUBCATEGORIA', 
    'ID_MARCA', 
    'DESCRIPCION_MARCA', 
    'enero', 
    'febrero', 
    'marzo', 
    'abril', 
    'mayo', 
    'junio', 
    'julio', 
    'agosto', 
    'septiembre', 
    'octubre', 
    'noviembre', 
    'diciembre',
  ]]  
}

  // DATOS DE EJEMPLO PARA LA DESCARGA DE LA PLANTILLA
  csvPruebaPresuPromocional() {
    return [
      { 
        'ORGANIZACION_VENTA'      : '1001', 
        'DESCRIPCION_ORGANIZACION_VENTA': 'LA FABRIL',
        'CANAL_VENTA'             : '10', 
        'DESCRIPCION_CANAL_VENTA' : 'B2B', 
        'UNIDAD_NEGOCIO'          : 'E01', 
        'DESCRIPCION_UNIDAD_NEGOCIO': 'CONSUMO', 
       /* 'CANAL'                   : "CANAL",
        'DESCRIPCION_CANAL'       : "DSC_CANAL",
        'SUBCANAL'                : 'Z06', 
        'DESCRIPCION_SUBCANAL'    : 'Clientes VDI', 
        'GRUPO_CLIENTE'            : "GRUPO CLIENTE",  
        'DESCRIPCION_GRUPO_CLIENTE': "DSCA_GRUPO CLIENTE",*/
        'ID_MATERIAL'             : '130000023', 
        'DESCRIPCION_MATERIAL'    : 'Descripción Material', 
        'MACROCATEGORIA'          : '1001', 
        'DESCRIPCION_MACROCATEGORIA': 'Descripción Macro', 
        'ID_CATEGORIA'            : '10012001', 
        'DESCRIPCION_CATEGORIA'   : 'Descripción Categoria1', 
        'ID_SUBCATEGORIA'         : '100120013001', 
        'DESCRIPCION_SUBCATEGORIA': 'Descripción Subcategoria1', 
        'ID_MARCA'                : '1001200130014001', 
        'DESCRIPCION_MARCA'       : 'Descripción Marca1', 
        'MES_1'                   : 89.98,
        'MES_2'                   : 10039, 
        'MES_3'                   : 568.77, 
        'MES_4'                   : 347.45, 
        'MES_5'                   : 249.99, 
        'MES_6'                   : 1000.55, 
        'MES_7'                   : 783.44, 
        'MES_8'                   : 982.10, 
        'MES_9'                   : 176.32, 
        'MES_10'                  : 599.11, 
        'MES_11'                  : 120.25, 
        'MES_12'                  : 56.90,
      },
      { 
        'ORGANIZACION_VENTA'      : '1001', 
        'DESCRIPCION_ORGANIZACION_VENTA': 'LA FABRIL',
        'CANAL_VENTA'             : '20', 
        'DESCRIPCION_CANAL_VENTA' : 'B2C', 
        'UNIDAD_NEGOCIO'          : 'E01', 
        'DESCRIPCION_UNIDAD_NEGOCIO': 'CONSUMO', 
       /* 'CANAL'                   : "CANAL",
        'DESCRIPCION_CANAL'       : "DSC_CANAL",
        'SUBCANAL'                : 'Z05', 
        'DESCRIPCION_SUBCANAL'    : 'Clientes Especiales',
        'GRUPO_CLIENTE'            : "GRUPO CLIENTE",  
        'DESCRIPCION_GRUPO_CLIENTE': "DSCA_GRUPO CLIENTE",*/
        'ID_MATERIAL'             : '130000023', 
        'DESCRIPCION_MATERIAL'    : 'Descripción Material', 
        'MACROCATEGORIA'          : '1001', 
        'DESCRIPCION_MACROCATEGORIA': 'Descripción Macro', 
        'ID_CATEGORIA'            : '10012001', 
        'DESCRIPCION_CATEGORIA'   : 'Descripción Categoria1', 
        'ID_SUBCATEGORIA'         : '100120013001', 
        'DESCRIPCION_SUBCATEGORIA': 'Descripción Subcategoria1', 
        'ID_MARCA'                : '1001200130014001', 
        'DESCRIPCION_MARCA'       : 'Descripción Marca1', 
        'MES_1'                   : 657.30, 
        'MES_2'                   : 890.00, 
        'MES_3'                   : 542.11, 
        'MES_4'                   : 120.50, 
        'MES_5'                   : 899.99, 
        'MES_6'                   : 347.88, 
        'MES_7'                   : 732.64, 
        'MES_8'                   : 1005.76, 
        'MES_9'                   : 877.32, 
        'MES_10'                  : 321.88, 
        'MES_11'                  : 250.10, 
        'MES_12'                  : 412.45,
      }
    ]
  }
  
}
